import React from 'react';

interface BonusSectionProps {
  onRegisterClick?: () => void;
}

const BonusSection: React.FC<BonusSectionProps> = ({ onRegisterClick }) => {
  return (
    <>
      {/* Spacer to prevent content from being hidden behind the fixed modal */}
      <div className="h-[120px] w-full block"></div>

      <section className="fixed bottom-16 left-0 right-0 z-30 px-0 pb-0">
        <div className="bg-white rounded-2xl px-3 py-4 shadow-[0_-4px_20px_rgba(0,0,0,0.1)] border border-gray-100">
          <div className="flex items-center gap-4 mb-4">
            {/* Badge icon */}
            <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0">
              <div className="w-8 h-8 rounded-full bg-red-600 flex items-center justify-center">
                <span className="text-white font-black text-sm">€</span>
              </div>
            </div>
            <div>
              <h3 className="text-base font-black text-gray-900 leading-tight">100 % Neukundenbonus</h3>
              <p className="text-xs text-gray-500 mt-0.5">Verdopple deine erste Einzahlung bis 100 €.</p>
            </div>
          </div>

          <button 
            onClick={onRegisterClick}
            className="w-full bg-red-600 text-white font-bold py-3 rounded-xl text-sm hover:bg-red-700 active:bg-red-800 transition"
          >
            Registrieren
          </button>
        </div>
      </section>
    </>
  );
};

export default BonusSection;
